var map = {
	"./button-text-block-quote-on.svg": 2281,
	"./button-text-block-quote.svg": 2282,
	"./button-text-bold-on.svg": 2283,
	"./button-text-bold.svg": 2284,
	"./button-text-bulleted-list-on.svg": 2285,
	"./button-text-bulleted-list.svg": 2286,
	"./button-text-deleted-on.svg": 2287,
	"./button-text-deleted.svg": 2288,
	"./button-text-formatting.svg": 1029,
	"./button-text-inline-code-on.svg": 2289,
	"./button-text-inline-code.svg": 2290,
	"./button-text-italic-on.svg": 2291,
	"./button-text-italic.svg": 2292,
	"./button-text-numbered-list-on.svg": 2293,
	"./button-text-numbered-list.svg": 2294,
	"./button-text-underlined-on.svg": 2295,
	"./button-text-underlined.svg": 2296
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2280;